import { render, staticRenderFns } from "./OptionsSavingTab.vue?vue&type=template&id=ff129252"
import script from "./OptionsSavingTab.vue?vue&type=script&lang=js"
export * from "./OptionsSavingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports